import { motion } from "framer-motion";
import { styled as stmu } from "@material-ui/core/styles"
import styled, { css } from "styled-components";
import { theme } from '../../theme'

export const Label = stmu('label')(({ theme }) => ({
    marginLeft: '0.8rem',
    fontWeight: 700,
    fontSize: '1.2rem',
}));

export const InputWrapperDiv = stmu('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
}));

export const CheckBoxInput = stmu('input')(({ theme }) => ({
    width: '15px',
    height: '15px',
}));

export const ErrorText = styled(motion.p)`
   margin: 0.1rem 0 0 0;
   color: ${theme.colors.redError};
   font-size: 1.4rem;
   letter-spacing: -0.01rem;
   font-weight: 700;

   ${({ easyFlow }) =>
        easyFlow &&
        css`
         margin: 0;
         position: absolute;
         left: 65px;
         bottom: -21px;
         font-size: 11.5px;
      `}
`;

export const Div = styled.div`
   ${({ fullWidth }) => fullWidth && "width: 100%;"}
   position: relative;
   display: inline-block;
   width: 100%;
`;
export const HelperText = styled.div`
    font-size: 1.2rem;
    color: #969696;
    margin-left: 2.3rem;
`;